import { defineStore } from 'pinia';

export const useGeneral = defineStore('general', {
  state: () => ({
    loading: false,
    loadingLocked: false,
    isDragging: false,
    plmLoadingQueue: [] as (() => void)[],
    prod: process.env.NODE_ENV === 'production',
    satra: false,
    headTitle: 'Resourced',
  }),

  getters: {
    plmLoading: (state) => {
      return Boolean(state.plmLoadingQueue.length);
    },

    // TODO: Consider setting this based on env
    showFeaturesInProgress: (state) => {
      // Set to true to see features currently under development
      const showNonReleasedFeatures = false;

      return showNonReleasedFeatures && !state.prod;
    },
  },

  actions: {
    loadingLock() {
      this.loadingLocked = true;

      return () => (this.loadingLocked = false);
    },

    startPlmLoading() {
      // Never wait for more than 60 seconds, then assume something went wrong
      const timeoutId = setTimeout(() => {
        throw new Error('PLM loading never stopped!');
      }, 60 * 1000);

      const stop = () => {
        clearTimeout(timeoutId);
        this.plmLoadingQueue = this.plmLoadingQueue.filter((fn) => fn !== stop);
      };

      this.plmLoadingQueue.push(stop);

      return stop;
    },
  },
});
